import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { Timezone } from '../types';

export const useSelectUserTimeZone = <X extends { timezone: string | null }>(
  setValue: UseFormSetValue<X>,
  timezones?: Timezone[],
) => {
  useEffect(() => {
    if (timezones) {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timezone = timezones.find(tz => tz.name.includes(userTimezone));
      if (timezone) {
        // @ts-ignore
        setValue('timezone', timezone.id);
      }
    }
  }, [timezones]);
};
